import washerIconSVG from '../../assets/icons/washer-color.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const WasherColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={washerIconSVG} {...props} />;
};
